<div *ngIf="loading" class="loader">
  <div class="spinner-border" role="status"></div>
</div>
<main class="campaign">
  <header class="campaign--header">
    <div class="campaign--header__container">
      <h5 class="campaign--header__title">
        {{ 'newRequestCampaginTitle' | i18next }}
      </h5>
      <div #stepperHeader></div>
    </div>
  </header>
  <app-stepper
    [user]="user"
    [requestType]="requestType"
    [steps]="steps"
    (sendRequestEmitter)="sendRequest($event)"
    (onCancel)="goHome()"
  ></app-stepper>
</main>
